/**
 * Watcher do aviso de fim do PRO — irmão do `PushPermissionWatcher` e do
 * `LeagueWeekRecapWatcher`.
 *
 * Montado uma única vez no `AppFrame`. Aqui só mora a montagem; todo o
 * "quando" vive em `useProLapseGate`. Sem auth, é no-op — e a checagem cara
 * (o read de `subscriptions/{uid}`) só acontece depois que as gratuitas já
 * disseram sim.
 */

import { lazy, Suspense } from "react";
import { useAuth } from "../../../hooks/useAuth";
import { useProLapseGate } from "../hooks/useProLapseGate";

// Lazy (17/09, rodada de performance): o cartão só existe para quem PERDEU o
// PRO, e o import estático o punha no entry de todo boot. Mesmo desenho nos
// outros três watchers de celebração do `AppFrame`.
const ProLapseModal = lazy(() =>
  import("./ProLapseModal").then((m) => ({ default: m.ProLapseModal })),
);

export function ProLapseWatcher() {
  const { user, profile } = useAuth();
  const { notice, dismiss } = useProLapseGate({
    uid: user?.uid ?? null,
    isPro: profile?.isPro,
    proExpiresAt: profile?.proExpiresAt ?? null,
  });

  if (!user || !notice) return null;

  return (
    <Suspense fallback={null}>
      <ProLapseModal notice={notice} onClose={dismiss} />
    </Suspense>
  );
}
